/**
 * The angularjs states related to the module LinkShortenerModule
 */
linkShortenerStates.$inject = ['$stateProvider'];
export function linkShortenerStates($stateProvider) {
    $stateProvider.state('auth.alcmeon.fuse.parameters.all-accounts.links', {
        url: '/links',
        views: {
            'container@auth': {
                template: '<angular-link-shortener></angular-link-shortener>',
            }
        }
    })
}